import { useContext, useEffect, useMemo, useState } from "react";
import { IAxiosError, api } from "../../../utils";
import { AvisContext } from "../../shared/context/AvisContext";
import { ErrorLoadingDataHoc } from "../../shared/error/ErrorLoadingDataHoc";
import { NoDataPage } from "../../shared/error/NoDataPage";

export function LinkedPersonsBailiffs() {
  const [loading, setLoading] = useState<boolean>(true);
  const [hasBailiffs, setHasBailiffs] = useState<boolean>(false);
  const [error, setError] = useState<IAxiosError>();

  const { ctxRightsHolder, res } = useContext(AvisContext);

  useEffect(() => {
    if (!ctxRightsHolder?.rightsHolderId) return;

    api
      .rightsHoldersGetRightsHoldersBailiffs(ctxRightsHolder.rightsHolderId)
      .then((res) => {
        if (typeof res.data?.value != "undefined")
          setHasBailiffs(res.data?.value);
      })
      .catch(setError)
      .finally(() => setLoading(false));
  }, [ctxRightsHolder?.rightsHolderId]);

  const renderContent = useMemo(() => {
    if (!hasBailiffs) return <NoDataPage />;

    return (
      <p className="avis-primary-text">
        {res("authors_LinkedPersons_HasBaififfsMessage")}
      </p>
    );
  }, [hasBailiffs, res]);

  return (
    <ErrorLoadingDataHoc error={error} loading={loading}>
      {renderContent}
    </ErrorLoadingDataHoc>
  );
}
